<template>
  <div class="app-container">
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table v-loading="listLoading" :data="tableData" size="mini" style="width: 100%">
        <el-table-column prop="id" label="id" width="80" />
        <el-table-column prop="type" label="类型" minWidth="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 0" type="info">导入</el-tag>
            <el-tag v-else type="primary">导出</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="file_name" label="文件名称" min-width="180" />
        <el-table-column prop="status" label="状态" minWidth="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" type="info">未开始</el-tag>
            <el-tag v-else-if="scope.row.status == 1" type="primary">进行中</el-tag>
            <el-tag v-else type="success">已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="desb" label="描述" min-width="120" />
        <el-table-column prop="created_att" label="开始时间" min-width="140" />
        <el-table-column prop="end_at" label="结束时间" min-width="140" />
        <el-table-column fixed="right" align="center" label="操作" width="120">
          <template slot-scope="scope">
            <div class="btns-wrap">
              <el-button type="danger" style="background: #1067e0;border-color: #1067e0;"
                @click="clickItem(scope.row)">下载</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total" :total="total" :page.sync="queryParam.page" :limit.sync="queryParam.size"
        @pagination="getList" />
    </div>
  </div>
</template>

<script>
import wuye from "@/api/tianzheng/wuye";
import Pagination from "@/components/Pagination"; // 分页
export default {
  data() {
    return {
      queryParam: {
        page: 1,
        size: 10
      },
      total: 0,
      listLoading: false,
      tableData: [],
    }
  },
  components: {
    Pagination
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 点击下载
    clickItem(row){
      // addr:"/export/物业费导出明细1770454160.xlsx"
      // window.open(row.addr);
      const link = document.createElement('a');
      link.href = this.$publicData.imgUrl+row.addr;
      link.download = row.file_name || 'file';
      link.click();
    },
    /* 查询tableData数据 */
    getList() {
      let that = this;
      that.listLoading = true;
      wuye.daoList(that.queryParam).then(res => {
        that.listLoading = false;
        that.tableData = res.result.list;
        that.total = res.result.total;
      });
    }
  }
}
</script>

<style></style>